import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  Observable,
  catchError,
  debounceTime,
  distinctUntilChanged,
  finalize,
  first,
  map,
  of,
  startWith,
  switchMap,
  take,
  tap,
} from 'rxjs';
import { CompanySearch } from 'src/app/interfaces/company-search.interface';
import { Products } from '../../../../../interfaces/products.interface';
import { UserProfileData } from '../../../../../interfaces/user-profile-data';
import { AccountsServiceService } from '../../../../../Services/accounts-service.service';
import { AuthService } from '../../../../../Services/Auth/auth.service';
import { BackendAccessService } from '../../../../../Services/APICalls/backend-access-service';
import { LoadingService } from '../../../../../Services/Loading/loading-service.service';
import { TechsupportSelectedCompanyOptionService } from '../../../../../Services/techsupport-selected-company-option.service';

@Component({
    selector: 'app-transfer-form-section',
    templateUrl: './transfer-form-section.component.html',
    styleUrls: ['./transfer-form-section.component.scss'],
    animations: [
        trigger('slideDownInOut', [
            state('void', style({
                opacity: 0,
                transform: 'translateY(-10%)',
            })),
            transition('void => *', animate('600ms ease-out')),
            transition('* => void', animate('600ms ease-in')),
        ]),
    ],
    standalone: false
})
export class TransferFormSectionComponent implements OnInit {
  someValue(someValue: any) {
    throw new Error('Method not implemented.');
  }
  @Input() siteIdDisplay = '';
  @Input() products: Products[] = [];

  @Output() validateData: EventEmitter<any> = new EventEmitter();
  @Output() validateSupportData: EventEmitter<any> = new EventEmitter();
  @Output() productData: EventEmitter<Products> = new EventEmitter();
  @Output() clearTheForm: EventEmitter<any> = new EventEmitter();
  @Output() updateSiteIdDisplay: EventEmitter<any> = new EventEmitter();

  public poCurrentText = '';
  public notesCurrentText = '';
  public notesCharsLeft: number = 512;
  public poCharsLeft: number = 64;
  public erasedChars = 0;

  transferForm!: UntypedFormGroup;
  categorySelection: string = '0';
  // products: Products[] = [];
  loading = false;
  options: CompanySearch[] = [];
  filteredOptions: Observable<CompanySearch[]> | undefined;
  accountId!: string;
  accountNumber!: string;
  businessId!: string;
  routeAccountId!: string;
  userProfileData!: UserProfileData | undefined;

  constructor(
    public rootFormGroup: FormGroupDirective,
    private backendAccessService: BackendAccessService,
    private accountsService: AccountsServiceService,
    public route: ActivatedRoute,
    public auth: AuthService,
    public loadingService: LoadingService,
    private techsupportSelectedCompanyOptionService: TechsupportSelectedCompanyOptionService
  ) {}
  /* istanbul ignore next */
  ngOnInit(): void {
    this.transferForm = this.rootFormGroup.control;
    // this.getProducts();

    if (
      this.transferForm.controls['productType'].value.duration === 1 ||
      this.transferForm.controls['productType'].value === '1: Object'
    ) {
      this.categorySelection = '1: Object';
    } else if (
      this.transferForm.controls['productType'].value.duration === 5 ||
      this.transferForm.controls['productType'].value === '2: Object'
    ) {
      this.categorySelection = '2: Object';
    } else {
      this.categorySelection = '0: Object';
    }

    this.auth
      .getUserProfile$()
      .pipe(take(1))
      .subscribe((results: UserProfileData) => {
        this.userProfileData = results;
        let roles: string[] = [];
        roles = this.userProfileData['http://allegion.com/claims/roles'];
        if (roles.some((role) => role === 'TechSupport')) {
        }
      });
    this.techsupportSelectedCompanyOptionService.selectedOption$
      .pipe(take(1))
      .subscribe((selectedOption) => {
        if (selectedOption) {
          this.transferForm.controls['accountId'].setValue(selectedOption);
          this.transferForm.controls['accountType'].setValue('Company Search');
        }
      });
  }

  /* istanbul ignore next */
  poChanged(event: any) {
    const newText = event.target.value;
    this.poCurrentText = newText;
    this.poCharsLeft = 64 - this.poCurrentText.length;
  }

  /* istanbul ignore next */
  notesChanged(event: any) {
    const newText = event.target.value;
    const previousLength = this.notesCurrentText.length;
    this.notesCurrentText = newText;
    this.notesCharsLeft = 512 - this.notesCurrentText.length;
    if (this.notesCurrentText.length < previousLength) {
      this.erasedChars = previousLength - this.notesCurrentText.length;
      this.notesCharsLeft += this.erasedChars;
    }
  }

  /* istanbul ignore next */
  ngAfterViewInit() {
    console.log('this.transferForm', this.transferForm);
    this.filteredOptions = this.transferForm.controls[
      'accountId'
    ].valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      startWith(''),
      tap((value) => console.log('Value changes detected:', value)), // Debugging purposes
      map((value) => (typeof value === 'string' ? value : value.businessId)),
      switchMap((businessId) =>
        businessId ? this.loadCompanies(businessId) : of(this.options.slice())
      )
    );
    this.autoSelectAccount();
  }

  getProducts() {
    this.backendAccessService
      .getProducts()
      .pipe(take(1))
      .subscribe(async (response: Products[]) => {
        this.products = await response.sort((a, b) =>
          a.duration > b.duration ? 1 : b.duration > a.duration ? -1 : 0
        );
        this.products.sort((a, b) =>
          a.duration > b.duration ? 1 : b.duration > a.duration ? -1 : 0
        );
      });
  }
  /* istanbul ignore next */
  clearForm() {
    this.clearTheForm.emit();
    this.transferForm.updateValueAndValidity();
  }
  /* istanbul ignore next */
  clearInput(accountType: string) {
    if (this.transferForm.controls[accountType] !== undefined) {
      this.transferForm.controls[accountType].reset();
    }
  }
  /* istanbul ignore next */
  onMouseWheel(e: Event) {
    e.preventDefault();
  }
  /* istanbul ignore next */
  displaySiteIdName(value: any) {
    this.updateSiteIdDisplay.emit(value);
  }
  private _filter(value: string): CompanySearch[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option: CompanySearch) =>
      option.businessId.toLowerCase().includes(filterValue)
    );
  }

  /* istanbul ignore next */
  displayName(subject: any): string {
    if (!subject || !this.userProfileData) {
      return '';
    }
    let roles: string[] = [];
    // gets roles from JWT
    roles = this.userProfileData['http://allegion.com/claims/roles'];
    if (
      subject.businessId &&
      roles.some((role) => role === 'TechSupport' || role === 'InternalAdmin')
    ) {
      return subject.businessId + '(' + subject.accountNumber + ')';
    } else if (subject.businessId) {
      return subject.businessId;
    } else {
      return ''; // Return an empty string if no conditions match
    }
  }

  /* istanbul ignore next */
  loadCompanies(value: string): Observable<CompanySearch[]> {
    if (!value) {
      return of([]); // Don't call the API if the input is empty
    }
    this.loadingService.show();
    return this.backendAccessService.searchAccounts(value).pipe(
      tap((results: CompanySearch[]) => {
        this.options = results;
      }),
      catchError((error) => {
        this.loadingService.hide();
        return of([]); // Return an empty observable in case of an error
      }),
      finalize(() => this.loadingService.hide())
    );
  }
  /* istanbul ignore next */
  autoSelectAccount() {
    this.route.params.pipe(first()).subscribe((res) => {
      if (res['accountId']) {
        this.accountsService.accounts.pipe(first()).subscribe((accounts) => {
          this.routeAccountId = res['accountId'];
          // console.log('this.options', this.options);
          let passedAccountOption = accounts.find(
            (o) => o.accountId === this.routeAccountId
          );
          this.transferForm.controls['accountType'].setValue('Company Search');
          this.transferForm.controls['accountId'].setValue(passedAccountOption);
        });
      }
    });
  }
  /* istanbul ignore next */
  numericOnly(event: any): boolean {
    // restrict e,+,-,E, and . characters in input type number
    const charCode = event.which ? event.which : event.keyCode;
    if (
      charCode === 101 ||
      charCode === 69 ||
      charCode === 45 ||
      charCode === 43 ||
      charCode === 46
    ) {
      return false;
    }
    return true;
  }
}
